import './OfferRevaluate.scss';
import React, { useState } from 'react';
import Button from '@atoms/Button';
import clsx from 'clsx';
import { MdClose } from 'react-icons/md';
import Modal from '@atoms/Modal';
import { IOffer } from '@models/winnerSelection/ITableDemand';
import { Controller, useForm } from 'react-hook-form';
import { WinnerSelectionService } from '@services/WinnerSelectionService';
import { sendNotification } from '@molecules/Notifications';
import Hint from '@atoms/Hint';
import { IOfferRevaluateFormData } from './IOfferRevaluateFormData';
import FormProviderControl from '@controls/FormProviderControl';
import HookFormProvider from '@controls/HookFormProvider';
import TextareaControl from '@controls/TextareaControl';

export interface IOfferRevaluateProps {
    tableKey: string;
    isEdit: boolean;
    value: IOffer;
    demandId: string;
    onSubmit?: (value: IOfferRevaluateFormData) => void;
    onClose?: () => void;
}

const OfferRevaluate = ({ tableKey, isEdit, value, demandId, onSubmit, onClose, ...props }: IOfferRevaluateProps) => {
    const [error, setError] = useState<string>();
    const methods = useForm<IOfferRevaluateFormData>({
        mode: 'onBlur',
        defaultValues: { revaluateComment: '' },
    });

    const { isSubmitting, isDirty } = methods.formState;

    const onClickClose = (e: any) => {
        onClose && onClose();
    };

    const onFormSubmit = async (form: IOfferRevaluateFormData) => {
        setError(undefined);
        return WinnerSelectionService.saveTableDemandOfferRevaluate(value.key, demandId, tableKey, form)
            .then((response) => {
                sendNotification({
                    message: 'Данные успешно сохранены',
                    variant: 'green',
                });
                onSubmit && onSubmit(form);
            })
            .catch((reason) => {
                setError(reason);
                console.log(reason);
            });
    };

    const errorLabel = error && (
        <div className="offer-revaluate__error">
            <Hint title={error} variant="red" />
        </div>
    );

    const ModalHeader = ({ onClose }: { onClose: (e: any) => void }) => (
        <div className={clsx('offer-revaluate-modal__header')}>
            <div className={clsx('offer-revaluate-modal__header-text')}>
                <span>{`Отправить предложение №${value.number || ''} (${value.name}) на переоценку?`}</span>
            </div>
            <div className={clsx('offer-revaluate-modal__header-close')}>
                <Button
                    buttonType="text"
                    textColor="neutral"
                    size="xs"
                    aria-label="Закрыть окно"
                    onClick={onClose}
                    startAdornment={<MdClose size="24" />}
                />
            </div>
        </div>
    );

    const ModalFooter = () => (
        <div className={'modal-dlg-buttons'}>
            <Button
                type="submit"
                form="offer-revaluate-form"
                preloader={isSubmitting}
                className={clsx('offer-revaluate__button', 'offer-revaluate__save-button')}
                disabled={isSubmitting || !isDirty}
            >
                ОК
            </Button>
            <Button onClick={onClose} buttonType="light">
                Отмена
            </Button>
        </div>
    );

    return (
        <Modal size="xl" header={<ModalHeader onClose={onClickClose} />} footer={isEdit ? <ModalFooter /> : null}>
            {errorLabel}
            <FormProviderControl
                formMethods={methods}
                id="offer-revaluate-form"
                className="offer-revaluate__form"
                onSubmit={onFormSubmit}
            >
                <HookFormProvider controller={Controller}>
                    <div className="offer-revaluate__content">
                        <div className="offer-revaluate__row">
                            <TextareaControl
                                label="Комментарий"
                                name="revaluateComment"
                                readOnly={!isEdit}
                                disabled={!isEdit}
                                autoResize={true}
                                formState={methods.formState}
                                control={methods.control}
                            />
                        </div>
                    </div>
                </HookFormProvider>
            </FormProviderControl>
        </Modal>
    );
};

export default OfferRevaluate;
